var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('icon-language', { attrs: { "code": _vm.item.code, "name": _vm.item.name, "resolver": _vm.iconResolver } });
};
var staticRenderFns = [];

export { render, staticRenderFns };